module.exports = __webpack_public_path__ + "img/calendar-outline-grey.aeb6c3fe.svg";